import { PRODUCT_LISTING_SET_PROP, ProductListingType, PRODUCT_LISTING_RECEIVE } from '../constants';

const DEFUALT_STATE = {
  products: [],
  facetFilters: [],
  totalProducts: null,
  productListingType: null,
  productListing: null,
};

export const productListing = (state = DEFUALT_STATE, action) => {
  const { type, payload } = action;
  switch (type) {
    case PRODUCT_LISTING_SET_PROP:
      return {
        ...state,
        ...payload,
      };
      case PRODUCT_LISTING_RECEIVE:
        return {
          ...state,
          ...payload,
        };
    default:
      return state;
  }
};
